import { Component } from 'react'
import { Box, Icons, KeyValueRow } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'
import { EncodingCounters } from 'stylewhere/api'
import { getEncodedOrder, getEncodedOrderRow, getExpectedOrder, getExpectedRow } from 'stylewhere/utils'

export interface EncodingCountersBoxProps {
  counters?: EncodingCounters
  productionOrderDetail?: () => void
  /** Pre-encoding work order: same `order` counters, work order label and no order detail action. */
  isWorkOrder?: boolean
}

export class EncodingCountersBox extends Component<EncodingCountersBoxProps> {
  render() {
    const { counters, productionOrderDetail, isWorkOrder } = this.props
    if (!counters?.order) return null

    const encodedOrder = getEncodedOrder(counters)
    const expectedOrder = getExpectedOrder(counters)
    const encodedOrderRow = getEncodedOrderRow(counters)
    const expectedOrderRow = counters?.row ? getExpectedRow(counters) : 0
    const orderLabel = isWorkOrder ? __(T.misc.work_order) : __(T.misc.item_order)
    const orderDetailAction = isWorkOrder ? undefined : productionOrderDetail

    return (
      <KeyValueRow style={{ margin: 2 }}>
        <KeyValueRow
          variant="raw"
          value={expectedOrder > 0 ? `${encodedOrder} / ${expectedOrder}` : `${encodedOrder}`}
          label={orderLabel}
          onClick={orderDetailAction}
          image={orderDetailAction ? <Icons.Info width={22} height={22} /> : undefined}
        />
        {counters?.row && (
          <>
            <Box height={60} width={2} bgGrey />
            <KeyValueRow
              variant="raw"
              value={expectedOrderRow > 0 ? `${encodedOrderRow} / ${expectedOrderRow}` : `${encodedOrderRow}`}
              label={__(T.misc.item_row)}
            />
          </>
        )}
      </KeyValueRow>
    )
  }
}
